import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { loyaltyVideoPlayerInputs } from "@/components/LoyaltyVideoPlayer/LoyaltyVideoPlayer.builder";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const loyaltyVideoPreviewInputs = loyaltyVideoPlayerInputs;

export const LoyaltyVideoPreviewComponent: RegisteredComponent = {
  name: "LoyaltyVideoPreview",
  component: dynamic(async () =>
    withValidation(
      loyaltyVideoPreviewInputs,
      (await import("./LoyaltyVideoPreview")).LoyaltyVideoPreview,
      "LoyaltyVideoPreview"
    )
  ),
  inputs: loyaltyVideoPreviewInputs,
};
